import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import NavMobile from './NavMobile';
import Socials from './Socials';
import { TiThMenuOutline } from 'react-icons/ti';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import DefaultLogo from '../img/header/logo.png';

const Header = () => {
  const [logo, setLogo] = useState(DefaultLogo);
  const [isActive, setIsActive] = useState(false);
  const [navMobile, setNavMobile] = useState(false);

  useEffect(() => {
    loadLogo();
  }, []);

  const loadLogo = async () => {
    try {
      const docRef = doc(db, 'shop', 'logo');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists() && docSnap.data().url) {
        setLogo(docSnap.data().url);
      }
    } catch (error) {
      console.error('Error loading logo:', error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsActive(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`${
        isActive ? 'h-[100px] lg:h-[110px] shadow-lg' : 'h-[120px] lg:h-[150px]'
      } fixed bg-white left-0 right-0 z-10 max-w-[1920px] w-full mx-auto transition-all duration-300`}
    >
      <div className="flex justify-between items-center h-full px-4 lg:px-[50px]">
        {/* logo - fixed size, centered in container */}
        <a href="/" className="flex-shrink-0 -ml-8 lg:ml-0">
          <div className={`${isActive ? 'w-[80px] h-[80px]' : 'w-[100px] h-[100px]'} flex items-center justify-center transition-all duration-300`}>
            <img 
              className="w-full h-full object-contain" 
              src={logo} 
              alt="Logo"
              style={{ imageRendering: 'crisp-edges' }}
              onError={(e) => {
                e.target.src = DefaultLogo;
              }}
            />
          </div>
        </a>
        {/* nav - initially hidden - show on desktop */}
        <div className="hidden xl:flex flex-grow justify-center">
          <Nav />
        </div>
        {/* socials - show only on desktop */}
        <div className="hidden xl:flex ml-auto">
          <Socials />
        </div>
        {/* nav menu button - hidden on desktop */}
        <div
          onClick={() => setNavMobile(!navMobile)}
          className="xl:hidden absolute right-[5%] bg-dark text-white p-2 rounded-md cursor-pointer"
        >
          <TiThMenuOutline className="text-3xl" />
        </div>
      </div>
      {/* nav mobile - show only on mobile */}
      <div
        className={`${
          navMobile ? 'max-h-full' : 'max-h-0'
        } ${
          isActive ? 'top-[100px] lg:top-[110px]' : 'top-[120px] lg:top-[150px]'
        } fixed bg-white w-full h-full left-0 -z-10 transition-all duration-300`}
      >
        <NavMobile />
      </div>
    </header>
  );
};

export default Header;